<template>
  <div class="body-width  div-top">
    <ul class="breadcrumb">
      <li  @mouseenter="handleEnter('/producthhxnsx/hhxnxl')" @mouseleave="handleLeave('/producthhxnsx/hhxnxl')" class="li-padding-left20">
        <a @click="setroters('/producthhxnsx/hhxnxl')">
          <span :class="hhxnxl===true?'font-Normal-1400':'font-Normal-14B6'">航海虚拟实训系列产品</span>
        </a>
      </li>      
      <li  @mouseenter="handleEnter('/producthhxnsx/hhxnkc')" @mouseleave="handleLeave('/producthhxnsx/hhxnkc')">
        <a @click="setroters('/producthhxnsx/hhxnkc')">
          <span :class="hhxnkc===true?'font-Normal-1400':'font-Normal-14B6'">航海虚拟课程</span>
        </a>
        
      </li>
      <li @mouseenter="handleEnter('/producthhxnsx/xnzhyl')" @mouseleave="handleLeave('/producthhxnsx/xnzhyl')">
        <a @click="setroters('/producthhxnsx/xnzhyl')">
          <span :class="xnzhyl===true?'font-Normal-1400':'font-Normal-14B6'">虚拟综合演练</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/producthhxnsx/hharxlxt')" @mouseleave="handleLeave('/producthhxnsx/hharxlxt')">
        <a @click="setroters('/producthhxnsx/hharxlxt')">
          <span :class="hharxlxt===true?'font-Normal-1400':'font-Normal-14B6'">航海AR训练系统</span>
        </a>
      </li>
    </ul>
  </div>

</template>
<script>
  export default {
    name: "hhxnsxxheader",
    data() {
      return {
        hhxnxl: true,
        hhxnkc: false,
        xnzhyl: false,
        hharxlxt: false,

        ishhxnxl:false,
        ishhxnkc:false,
        isxnzhyl:false,
        ishharxlxt:false,
      }
    },
    methods: {
      handleEnter(src) {
        if (src === '/producthhxnsx/hhxnxl') {
          this.hhxnxl = false
        }
        if (src === '/producthhxnsx/hhxnkc') {
          this.hhxnkc = true
        }
        if (src === '/producthhxnsx/xnzhyl') {
          this.xnzhyl = true
        }
        if (src === '/producthhxnsx/hharxlxt') {
          this.hharxlxt = true
        }
      },
      handleLeave(src) {
        if (src === '/producthhxnsx/hhxnxl') {
          if(!this.ishhxnxl){
            this.hhxnxl = true
          }
        }
        if (src === '/producthhxnsx/hhxnkc') {
          if(!this.ishhxnkc){
            this.hhxnkc = false
          }
        }
        if (src === '/producthhxnsx/xnzhyl') {
          if(!this.isxnzhyl){
            this.xnzhyl = false
          }
        }
        if (src === '/producthhxnsx/hharxlxt') {
          if(!this.ishharxlxt){
            this.hharxlxt = false
          }
        }
      },

      setroters(src) {
        if (src === '/producthhxnsx/hhxnxl') {
          this.hhxnxl = true
          this.ishhxnxl = true
        } else {
          this.hhxnxl = false
          this.ishhxnxl = false
        }
        if (src === '/producthhxnsx/hhxnkc') {
          this.hhxnkc = true
          this.ishhxnkc = true
        } else {
          this.hhxnkc = false
          this.ishhxnkc = false
        }
        if (src === '/producthhxnsx/xnzhyl') {
          this.xnzhyl = true
          this.isxnzhyl = true
        } else {
          this.xnzhyl = false
          this.isxnzhyl = false
        }
        if (src === '/producthhxnsx/hharxlxt') {
          this.hharxlxt = true
          this.isharxlxt = true
        } else {
          this.hharxlxt = false
          this.isharxlxt = false
        }
        this.$router.push(src);
      }
    },
    mounted() {
      this.setroters('/producthhxnsx/hhxnxl');
    }
  }

</script>

<style scoped>
  .div-top {
    margin-top: 50px;
  }
.breadcrumb{
   background-color: #fbfbfb !important;
}
  .breadcrumb > li + li:before {
 
    color: #666666;
    content: "| ";
    padding: 0 16px;
  }
  .li-padding-left20 {
    padding-left: 20px;
  }

/*.font-Normal-1400 {
  font-size: 20px; 
  font-weight: 600;
  原先尺寸
}
.font-Normal-14B6 {
  font-size: 17px;
  font-weight: 600;
同步加大
}
*/

.font-Normal-1400,
.font-Normal-14B6 {
  font-size: 17px; /* 固定基础字号，两个class字号保持一致 */
  font-weight: 600;
  /* 新增缩放过渡，只做视觉变化，不改变布局 */
  transition: transform 0.2s ease;
  display: inline-block; /* transform生效必备 */
  transform-origin: center; /* 居中放大，避免单侧偏移拉扯 */
}

/* 选中态只用scale放大，不改字号 */
.font-Normal-1400 {
  transform: scale(1.15); /* 视觉放大效果，替代增大font-size */
}


</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/hhxnsxxlcp/hhxnsxxheader.vue